import { useEffect, useState } from "react";
import { X, Megaphone } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PromoBanner() {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    fetch(`${API}/banner`)
      .then((r) => r.json())
      .then((d) => {
        if (d.enabled && !sessionStorage.getItem(`promo_dismissed_${encodeURIComponent(d.message)}`)) setBanner(d);
      })
      .catch(() => {});
  }, []);

  if (!banner) return null;

  const dismiss = () => {
    sessionStorage.setItem(`promo_dismissed_${encodeURIComponent(banner.message)}`, "1");
    setBanner(null);
  };

  return (
    <div data-testid="promo-banner" className="relative z-[60] bg-brand-green text-white">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-3 gap-y-1 px-10 py-2.5 text-center text-sm">
        <Megaphone className="h-4 w-4 shrink-0" />
        <p className="font-medium" data-testid="promo-banner-message">{banner.message}</p>
        {banner.cta_url && (
          <a
            href={banner.cta_url}
            data-testid="promo-banner-cta"
            className="rounded-full bg-white px-3 py-0.5 text-xs font-bold text-brand-greendark transition-colors duration-200 hover:bg-brand-cream"
          >
            {banner.cta_text || "Book now"}
          </a>
        )}
      </div>
      <button
        onClick={dismiss}
        data-testid="promo-banner-dismiss"
        aria-label="Dismiss banner"
        className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-1 transition-colors duration-200 hover:bg-white/20"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
